/**
 * Safe metric display helpers
 * Prevents "undefined%", "NaN%", and similar display bugs
 */

/**
 * Safely format a metric value with optional suffix/prefix
 * Returns fallback when val is null/undefined/NaN
 */
export function safeMetric(
  val: number | string | null | undefined,
  suffix: string = '',
  prefix: string = '',
  fallback: string = '—'
): string {
  if (val === null || val === undefined || val === '' || (typeof val === 'number' && isNaN(val))) {
    return fallback;
  }
  return `${prefix}${val}${suffix}`;
}

/**
 * Safely format a count value with toLocaleString
 * Returns "0" when val is null/undefined/NaN
 */
export function safeCount(val: number | null | undefined): string {
  if (val === null || val === undefined || isNaN(val)) {
    return '0';
  }
  return val.toLocaleString();
}

/**
 * Safe division returning null when denominator is 0
 */
export function safeRate(
  numerator: number | null | undefined,
  denominator: number | null | undefined,
  precision: number = 1
): number | null {
  if (
    numerator === null || numerator === undefined || isNaN(numerator) ||
    denominator === null || denominator === undefined || isNaN(denominator) ||
    denominator === 0
  ) {
    return null;
  }
  return parseFloat(((numerator / denominator) * 100).toFixed(precision));
}
